import axios from 'axios';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchManualPreadviceTransactionsDelete = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'deleteManualPreadviceTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.delete(serviceUrl, {
    data: {
      comments: payload.params.comments,
      transactionIdList: payload.params.transactionIdList,
    },
  });
};

export default apiFetchManualPreadviceTransactionsDelete;
